import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: "sortByClickedSequence"
})

export class SortByClickedSequencePipe implements PipeTransform {
  transform(collection: Array<any>, args: string): Array<any> {
    const notes = Object.values(collection);
    notes.sort((a: any, b: any) => {
      if (a.clickedSequence < b.clickedSequence) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
    return notes;
  }
}